import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const apiKey = import.meta.env.VITE_FIREBASE_API_KEY;
const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;
const authDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'primedocumentsign.firebaseapp.com';
const storageBucket = import.meta.env.VITE_FIREBASE_STORAGE_BUCKET;
const messagingSenderId = import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID;
const appId = import.meta.env.VITE_FIREBASE_APP_ID;
const measurementId = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID;

if (!apiKey || !projectId || !appId) {
  throw new Error(
    'Firebase config missing. Add VITE_FIREBASE_API_KEY, VITE_FIREBASE_PROJECT_ID, and VITE_FIREBASE_APP_ID to your .env file. Get these from Firebase Console → Project settings.'
  );
}

const firebaseConfig = {
  apiKey,
  authDomain,
  projectId,
  storageBucket,
  messagingSenderId,
  appId,
  measurementId: measurementId || undefined,
};

export const app = initializeApp(firebaseConfig);

/** Defer Analytics SDK off the critical path (dynamic import + idle / delayed task). */
if (typeof window !== 'undefined' && measurementId) {
  const bootAnalytics = () => {
    import('firebase/analytics')
      .then(({ getAnalytics }) => {
        try {
          getAnalytics(app);
        } catch (_) {
          /* ignore — e.g. blocked storage */
        }
      })
      .catch(() => {});
  };
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(bootAnalytics, { timeout: 4000 });
  } else {
    setTimeout(bootAnalytics, 2000);
  }
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

/** GCP project id (for admin links to Cloud Console). */
export const firebaseProjectId = projectId;
